<div>

  <div class="row">
    @if (tabSelected === 'E' || tabSelected === 'P') {
      <div class="col-lg-6">
        @if (tabSelected === 'E') {
          <app-sales-event-selection [hasOther]="this.hasPassePartouts || this.hasMemberships || this.hasCrossSellProductVariants" [isReservation]="isReservation" (onEventSelectionChange)="onEventSelection($event)"></app-sales-event-selection>
        }
        @if (tabSelected === 'P') {
          <app-sales-passepartout-selection [hasOther]="this.hasEvents || this.hasMemberships || this.hasCrossSellProductVariants" (onPassePartoutSelectionChange)="onPassePartoutSelection($event)"></app-sales-passepartout-selection>
        }
      </div>
    }

    <div class="col-lg-6" [class.d-none]="tabSelected !== 'E' && tabSelected !== 'P'">

      <div class="card order-height h-100" style="min-height: 450px;">

        <div class="card-header section-selection p-0">

          <div class="row g-0">
            <div class="col-sm-8 col-sm-8 ps-5 pt-2">
              <h6>{{'SALES.ORDERS.NEW.SALES-SECTION-SELECTION.HEADER' | translate}}</h6>
            </div>
            <div class="col-sm-4 text-end p-1 ">
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-secondary" (click)="setMapMode(true)" [class.active]="inMapMode === true" ><i class="far fa-map"></i></button>
                <button type="button" class="btn btn-secondary" (click)="setMapMode(false)" [class.active]="inMapMode === false"><i class="far fa-list-alt"></i></button>
              </div>
            </div>
          </div>

        </div>

        <div class="map-holder">

          @if (displayVenue === false) {
            @if (hasVenuePlan === true) {
              <div class="p-5">{{'SALES.ORDERS.NEW.SALES-SECTION-SELECTION.MSG' | translate}}</div>
            }
          }

          <div [class.d-none]="displayVenue === false || inMapMode === false" class="h-100" fxLayoutAlign="center center">

            <div [class.d-none]= "" style="width: 100%;">
              @if (hasVenuePlan === false) {
                <div class="p-5">{{'SALES.ORDERS.NEW.SALES-SECTION-SELECTION.MSG.NOVENUEPLAN' | translate}}</div>
              }
              <app-venue-renderer [class.d-none]= "hasVenuePlan === false" (onSectionClicked)="handleSectionClick($event)"></app-venue-renderer>
            </div>

          </div>


          <div [class.d-none]="displayVenue === false || inMapMode === true">

            <t4-list-view #listVw [options]="listOptions" (onDirectSelection)="selectSection($event)" (onItemSelectionChange)="OnItemSelectionChange($event)" (onDataRequest)="OnDataRequest($event)">
              <ng-container *t4ListItem="let item">

                <td>{{ item.Name }}</td>
                <td>{{ sectionAvailability(item) }}</td>

              </ng-container>
            </t4-list-view>

          </div>
        </div>
      </div>
    </div>

    @if (tabSelected === 'M') {
      <div class="col-lg-12">
        @if (tabSelected === 'M') {
          <app-sales-membership-selection [hasOther]="this.hasEvents || this.hasPassePartouts || this.hasCrossSellProductVariants || this.hasMatchDayPasses" (onMembershipSelectionChange)="onMembershipSelection($event)"></app-sales-membership-selection>
        }
      </div>
    }

    @if (tabSelected === 'C') {
      <div class="col-lg-12">
        @if (tabSelected === 'C') {
          <app-sales-crosssellproductvariant-selection [hasOther]="this.hasEvents || this.hasPassePartouts || this.hasMemberships || this.hasMatchDayPasses" (onCrossSellProductVariantChange)="onCrossSellProductVariantSelection($event)"></app-sales-crosssellproductvariant-selection>
        }
      </div>
    }

    @if (tabSelected === 'D') {
      <div class="col-lg-12">
        <app-sales-matchdaypass-selection [hasOther]="this.hasEvents || this.hasPassePartouts || this.hasCrossSellProductVariants || this.hasMemberships" (onMatchdaypassSelectionChange)="onMatchdaypassSelectionChange($event)"></app-sales-matchdaypass-selection>
      </div>
    }

  </div>
</div>

